import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import Modal from '../shared/modal';
import { ModalBodyContainer, FieldTitles, FieldDescriptiveNote } from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { isValidEmail } from '../../utils/utils';

const ContractEmails = ({ open = false, setOpen, setData, signingAuthorityEmail }) => {
  const [email, setEmail] = useState(`${signingAuthorityEmail}`);
  const [emailError, setEmailError] = useState('');
  const [ccEmail, setCCEmail] = useState('');
  const [ccEmailError, setCCEmailError] = useState('');

  const localizedString = useLocalizedStringsContext();

  const {
    ORDERS: {
      emailDetail: {
        contractAddress,
        contractAddressDetail,
        CCEmailAddress,
        CCEmailAddressDetail,
        confirm,
        emptyEmail,
        invalidEmail,
        CCEmailInvalid,
        header
      }
    }
  } = localizedString;

  const isValidated = () => {
    let check = true;
    if (email.length === 0) {
      setEmailError(emptyEmail);
      check = false;
    } else if (!isValidEmail(email)) {
      setEmailError(invalidEmail);
      check = false;
    }
    if (ccEmail.length > 0) {
      const ccEmails = ccEmail.replaceAll(' ', '').split(',');
      let totalCount = 0;
      ccEmails.forEach(emailAddress => {
        if (!isValidEmail(emailAddress)) {
          totalCount += 1;
        }
      });
      if (totalCount > 0) {
        setCCEmailError(`${totalCount} ${CCEmailInvalid}`);
        check = false;
      }
    }
    return check;
  };

  const onSubmit = () => {
    if (isValidated()) {
      setOpen(false);
      const emailData = {
        contractEmail: email,
        contractEmailCC: ccEmail
      };
      if (typeof setData === 'function') {
        try {
          setData(emailData);
        } catch (error) {
          console.error('ContractEmails onSubmit - ERROR calling setData:', error);
        }
      }
    }
  };

  return (
    <Modal header={header} open={open} setOpen={setOpen}>
      <ModalBodyContainer>
        <FieldTitles>{contractAddress}</FieldTitles>
        <FieldDescriptiveNote>{contractAddressDetail}</FieldDescriptiveNote>
        <input
          className="frg-input-field color-light"
          value={email}
          onChange={e => {
            setEmailError('');
            setEmail(e.target.value);
          }}
        />
        <p style={{ color: '#c12335', fontSize: '0.875rem' }}>{emailError}</p>
        <FieldTitles>{CCEmailAddress}</FieldTitles>
        <FieldDescriptiveNote>{CCEmailAddressDetail}</FieldDescriptiveNote>
        <input
          className="frg-input-field color-light"
          value={ccEmail}
          onChange={e => {
            setCCEmail(e.target.value);
          }}
        />
        <p style={{ color: '#c12335', fontSize: '0.875rem' }}>{ccEmailError}</p>
        <Button
          type="button"
          onPress={() => {
            onSubmit();
          }}
        >
          {confirm}
        </Button>
      </ModalBodyContainer>
    </Modal>
  );
};

ContractEmails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setData: PropTypes.func.isRequired,
  signingAuthorityEmail: PropTypes.string.isRequired
};

export default ContractEmails;
